module.exports = __webpack_public_path__ + "media/images/top/about-takumen-7de0cde7d2786b4cbbfa5db07fc2040d.webp";